/* eslint-disable react-hooks/exhaustive-deps */

import React,{useState,useEffect,useRef, useContext} from 'react'
import moment from 'moment';
import { IoPerson } from "react-icons/io5";
import { MdAddBox } from "react-icons/md";
import { NGODatePicker} from '../../../../common';
import LoadingIn from '../../../../assets/loadingIn.gif';
import deposit from "../../../../assets/deposit.svg";
import { FaFilter } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import searchIcon from '../../../../assets/icons/search.svg';
import Select from 'react-select';
import {ThemeContext} from "../../../../contexts/themeContext";
import {customSelSearch} from '../../../../utils/configs';

const SectorListing=(props)=> {
    const{setPage,page}=props;
    const { t,ready } = useTranslation();
    const [sectorListing,setSectorListing] =useState([]);
    const [showLoading, setShowLoading] = useState(null);
      const {themedColor} = useContext(ThemeContext);

    const sectorListContainerRef = useRef(null);
    useEffect(() => {
        !props.loadSectorListing? setShowLoading('No Sectors Found.'): setShowLoading('Loading...')
    }, [props.loadSectorListing]);

    useEffect(() => {
      setSectorListing(props.sectorListing);
  }, [props.sectorListing]);

    useEffect(() => {
      const container = sectorListContainerRef.current;

      if (container) {
        container.addEventListener('scroll',scrollLimitCheck(handleScroll,450));
      }

      return () => {
        if (container) {
          container.removeEventListener('scroll',scrollLimitCheck(handleScroll,450));
        }
      };
    }, [showLoading, page]);

  const handleScroll = (e) => {
    let tolerance=2;
      if (Math.abs(Math.floor(e.target.scrollHeight) - Math.floor(e.target.scrollTop + e.target.clientHeight)) <= tolerance) {
        setShowLoading('Loading...');
        setPage((prevPage) => prevPage + 1);
      }
    };

    function scrollLimitCheck(func, delay) {
      let lastTime = 0; 
      return function() {
        const now = new Date().getTime();
        if (now - lastTime >= delay) {  
          func.apply(this, arguments); 
          lastTime = now;  
        }
      };
    }

const attachSectorList=(list)=>{
props.attachSector(list.id)
if (sectorListContainerRef.current) {
  sectorListContainerRef.current.scrollTop = sectorListContainerRef.current.scrollHeight;
}
}
const onSectorChange=(e)=>{
props.setSectors([e])
}
const onEmployeeChange=(e)=>{
props.setEmployee([e])
}
const onFlightDateChange=(e)=>{
props.setFilghts(e.target.value)
}
const onSearch=(e)=>{
  if(!e.target.value){
  setPage(1);
  }
props.setSearchKeyOrders(e.target.value)
}
function searchFiltersInList(){
  setPage(1);
  props.setSectorListing([]);
  props.setFilterSectors(prevState => !prevState);
}

const eventLogView=(sec)=>{

    const listItems = sec?.map((list,index) =>
    {
      return(
      <React.Fragment key={index}>
        <div>
          <li className="list-group-item-sector-list">
            <div className='row justifyContentCenter alignItemsCenter'>
              <div  style={{width:'100%'}}>
                <div  className='flexRow justifyContentSpaceBetween'style={{padding:'5px'}}>
                <div className='flexRow justifyContentFlexStart'><strong>{list?.name}</strong>{list?.isolateAffinity?.name?<span className='code'>{list?.isolateAffinity?.name}</span>:<></>} </div>  <div className='flexRow justifyContentFlexEnd'><IoPerson size={17} style={{ marginRight: '3px' }} /><span style={{ paddingTop:'3px'}}>{list.createdBy.employeeName} @ {moment(list.createdAt).format('DD-MM-YYYY  hh:mm A')}</span>&nbsp;<div title='Attach this sector' onClick={()=>attachSectorList(list)}><MdAddBox size={20} style={{cursor:'pointer'}} color='green'/></div></div>

                </div>
              </div>
            </div>
          </li>
        </div>
      </React.Fragment>

      )

    }
     );
     return listItems
      }

  return (
    <>
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
    {
            <>
                <div className='flexRow width100 margBot10 margTop8 justifyContentSpaceBetween alignItemsCenter tableFilterBlocks'>
                    <div className="flexRow justifyContentFlexStart alignItemsCenter leftBlock">
                        <div className="flexRow justifyContentFlexEnd alignItemsBaseline">
                          <div className=' item-button margRight10'><Select
                                options={props.stores}
                                value={props.stores?.filter(function (option) {
                                  return (
                                    props.sectors.length && props.sectors[0]&&
                                    props.sectors.find((sc) => sc.label === option.label)
                                  );
                                })}
                                onChange={onSectorChange}
                                styles={customSelSearch(themedColor)}
                                placeholder="Search Sectors"
                                isSearchable={true}
                                isClearable={true}
                                className="selectMenu-meals"
                              /></div>
                        <div className=' item-button margRight10'><Select
                                options={props.employees}
                                value={props.employees?.filter(function (option) {
                                  return (
                                    props.employee.length && props.employee[0]&&
                                    props.employee.find((sc) => sc.label === option.label)
                                  );
                                })}
                                onChange={onEmployeeChange}
                                styles={customSelSearch(themedColor)}
                                placeholder="Search Employee"
                                isSearchable={true}
                                isClearable={true}
                                className="selectMenu-meals"
                              /></div>


                        <> <div className='flexCol'>

                    <NGODatePicker
                      style={{width: '12rem'}}
                      value={props.flights}
                      className="input-margin"
                      name="startDate"
                      isclearable={true}
                      placeholder={t('Flight Date')}
                      placeholdertext={t('datePickerPlaceholder')}
                       onChange={onFlightDateChange}
                      />
                        </div>

                  </>
                 <div title="Apply Filter" className='filter-set' onClick={searchFiltersInList}><FaFilter size={20} color='white' /></div>
                        </div>
                    </div>
                    <div className="flexRow justifyContentFlexEnd rightBlock underline margLeft10">
                    <span><img className='icon-size margTop5' src={searchIcon} alt={t('filters.searchText')} /></span>
                    <span><input className="search-layout"  onChange={onSearch} value={props.searchKeyOrders} type="search" placeholder="Search" /></span>
                    </div>
                </div>


                <div id="sectorListContainer"  ref={sectorListContainerRef} className={props?.data?"width100 dialog__body_container flexRow justifyContentSpaceBetween flexWrap sm-scrollbar":"dialog__body_container flexRow justifyContentSpaceBetween flexWrap sm-scrollbar"} style={{overflowY:'scroll',overflowX:'hidden',height:'85vh'}}>
           {sectorListing.length? <ul className='list-group'>
                {eventLogView(sectorListing)}
                </ul>:<div className="flexRow w-100 h-100 justifyContentCenter alignItemsCenter">{showLoading && showLoading.includes('Loading...')?<div className="flexRow justifyContentCnter alignItemsCenter"><img src={LoadingIn}  className="loading-img" alt="Loading" />&nbsp;<span className="margTop8">Please wait while we load the sectors</span></div>:<div className='flexCol'>{showLoading}
                <button className='small-body-text-regular fontExtrabold key-value btn-sync margTop8'>
          <img style={{height:'40px',width:"40px",backgroundColor:"#4c5c81",borderRadius:"4px"}} src={deposit} onClick={()=>props.setFilterSectors(prev=>!prev)} alt='refresh-sectors' />
          </button>

                </div>}</div>}
          </div>
            </>
        }

        {
          !ready &&<div className='overlay_hide sub'></div>
        }
    </div>
</>
  )
}

export default SectorListing;